(function() {
    'use strict';

    angular
        .module('quantixApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$ocLazyLoadProvider'];

    function stateConfig($stateProvider,$ocLazyLoadProvider) {
    	
    	$ocLazyLoadProvider
		.config({
			'debug' : false, /*
								 * for debugging ocLazyLoad module
								 * 'true/false'
								 */
			'events' : true, /*
								 * for event ocLazyLoad module
								 * 'true/false'
								 */
			'modules' : [ {
				name : 'ratingModule', /*
									 * injecting 
									 * Module for ocLazyLoad
									 */
				/* files for lazy load */
				files : [
						'app/services/portfolio/portfolio.service.js',
						'app/services/companyProfile/companyProfile.service.js'
						 ]
			} ]
		});
    	
        $stateProvider
        .state('ratingList', {
            parent: 'app',
            url: '/ratingList',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/ratingList/ratingList.html',
                    controller: 'RatingListController',
                    controllerAs: 'vm'
                }
            },
            resolve : {
				loadMyCtrl : [
						'$ocLazyLoad',
						function($ocLazyLoad) {
							return $ocLazyLoad
									.load('ratingModule'); /*
														 * Resolve
														 * promise
														 * and
														 * load
														 * before
														 * view
														 */
						} ],
			}
        });
    }
})();
